import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const StyledButton = styled.button<{ backgroundImage?: string; dark: boolean }>`
  position: relative;
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  flex: 1 0 45%;
  padding: 12px 16px;
  min-height: 144px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.16);
  text-decoration: none;
  font: var(--text-body-l);
  font-weight: 900;
  cursor: pointer;
  outline: none;
  border: none;
  text-align: left;
  width: 100%;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(23, 25, 28, 0.3);
  }

  div {
    color: ${({ dark }) =>
      dark
        ? 'var(--text-color-headline)'
        : 'var(--text-color-headline-invert)'};
  }
`;

const Tile = ({
  children,
  dark,
  href,
  backgroundImage,
  onClick,
  ...htmlProps
}: {
  backgroundImage?: string;
  children: React.ReactNode;
  dark?: boolean;
  href: string;
  onClick: () => void;
}) => {
  const navigate = useNavigate();
  return (
    <StyledButton
      {...htmlProps}
      onClick={() => {
        navigate(href);
        onClick();
      }}
      backgroundImage={backgroundImage}
      dark={!!dark}
    >
      {children}
    </StyledButton>
  );
};

export default Tile;
